/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateKpiReportCommand } from '../../models/update-kpi-report-command';
import { UpdateKpiReportCommandResult } from '../../models/update-kpi-report-command-result';

export interface ApiKpiReportsUpdateKpiReportsPost$Params {
      body?: UpdateKpiReportCommand
}

export function apiKpiReportsUpdateKpiReportsPost(http: HttpClient, rootUrl: string, params?: ApiKpiReportsUpdateKpiReportsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateKpiReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsUpdateKpiReportsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateKpiReportCommandResult>;
    })
  );
}

apiKpiReportsUpdateKpiReportsPost.PATH = '/api/KPIReports/UpdateKPIReports';
